// Routes where the app sidebar is never shown (landing, auth, and legal pages).
// Shared by MainLayout (renders the sidebar) and AppHeader (offsets its own
// layout to leave room for the sidebar) so the two can never disagree about
// which pages have one.
// AppHeader is `fixed` and lays a 72px spacer beneath itself as a sibling of
// MainLayout. A page body that also asks for a full viewport therefore makes
// the document 100vh + 72px tall — a phantom scrollbar on pages that actually
// fit. Anything filling the viewport under the header must subtract it.
//
// Written out as complete class names: Tailwind scans source text and cannot
// see a class composed at runtime.
export const BELOW_HEADER_MIN_H = "min-h-[calc(100vh-72px)]";

export const SIDEBAR_HIDDEN_PATHS = [
  "/",
  "/login",
  "/register",
  "/privacy-policy",
  "/terms-and-conditions",
  "/refund-policy",
  "/privacy",
  "/terms",
  "/terms-of-service",
];
